import {Component, OnInit } from '@angular/core';
import { AppUtilService } from 'app/services/app-util.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'session-expired',
  templateUrl: './session-expired.component.html',
  styleUrls: ['../app.scss', '../login/login.template.scss']
})
export class SessionExpiredComponent implements OnInit {
  constructor(
    private appUtil: AppUtilService
  ) {}

  public ngOnInit(): void {
    this.appUtil.setTitle('Session Expired');
  }

}
